module.exports = __webpack_public_path__ + "static/media/wechat-svg.a2540835.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechat-svg.svg
// module id = 542
// module chunks = 0